import React from 'react';
import { FileQuestion, Mail } from 'lucide-react';
export function LostCertificates() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1396" data-mp="1bassx72kn79k">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1397" data-mp="1bdopaqyrtnvw">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1398" data-mp="16ij7a38hotd3">
          <div className="flex items-center justify-center mb-4" data-id="element-1399" data-mp="11m125298yt08">
            <FileQuestion className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1400" data-mp="11jonoz2p70rx" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1401" data-mp="wnzhicw6almn">
              Lost Certificates
            </h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-8" data-id="element-1402" data-mp="nkyh8stznoqw">
          <div className="bg-gray-50 rounded-lg p-5 sm:p-8" data-id="element-1403" data-mp="nm01nnww9nla">
            <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-1404" data-mp="ingbfbb9ppn4">
              If you have lost or misplaced a certificate to a class you
              attended with Desert Sage Seminars, you will need a replacement
              before you attempt to renew your license.
            </p>

            <div className="bg-brand-purple-50 rounded-lg p-4 sm:p-6 border-2 border-brand-purple-200" data-id="element-1405" data-mp="1rcbb3vdvx8b2">
              <div className="flex items-start" data-id="element-1406" data-mp="1vf7o96knoc7m">
                <Mail className="w-6 h-6 text-brand-purple-600 mr-3 mt-1 flex-shrink-0" data-id="element-1407" data-mp="1vbtlvybzs306" />
                <div className="min-w-0 flex-1" data-id="element-1408" data-mp="1hghspvdhikld">
                  <p className="text-base text-gray-700 break-words" data-id="element-1409" data-mp="1mcoowwg2whq4">
                    For a replacement, contact us via e-mail at{' '}
                    <a href="mailto:Administration@DesertSageSeminars.com" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold break-words [overflow-wrap:anywhere]" data-id="element-1410" data-mp="2a3ucxyw6agbi">
                      Administration@DesertSageSeminars.com
                    </a>{' '}
                    or click on CONTACT on the Home Page to send direct email
                    with your request including the name, date and location of
                    the class.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}